/**
 * @generated SignedSource<<7685cf34fdf5d3d24c4c067a6a0560d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BankCode = "bankBU" | "bankCT" | "bankCU" | "bankDG" | "bankHN" | "bankIB" | "bankJB" | "bankJJ" | "bankKA" | "bankKB" | "bankKD" | "bankKJ" | "bankKK" | "bankKN" | "bankMG" | "bankNH" | "bankPO" | "bankSC" | "bankSH" | "bankSU" | "bankWR";
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type checkTokenAndBankAccountMutation$variables = {
  account: string;
  bankCode: BankCode;
  code: string;
};
export type checkTokenAndBankAccountMutation$data = {
  readonly checkBankAccountByCode: {
    readonly errors: {
      readonly code: ErrorType;
    } | null | undefined;
    readonly hometaxBizName: string | null | undefined;
    readonly name: string | null | undefined;
    readonly result: boolean;
    readonly taxpayerName: string | null | undefined;
  };
};
export type checkTokenAndBankAccountMutation = {
  response: checkTokenAndBankAccountMutation$data;
  variables: checkTokenAndBankAccountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "account"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bankCode"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "code"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "account",
        "variableName": "account"
      },
      {
        "kind": "Variable",
        "name": "bankCode",
        "variableName": "bankCode"
      },
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "code"
      }
    ],
    "concreteType": "CheckTokenAndBankAccountOutput",
    "kind": "LinkedField",
    "name": "checkBankAccountByCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taxpayerName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hometaxBizName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "checkTokenAndBankAccountMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "checkTokenAndBankAccountMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "a3a30633eae8557953bdb6b6fb665a52",
    "id": null,
    "metadata": {},
    "name": "checkTokenAndBankAccountMutation",
    "operationKind": "mutation",
    "text": "mutation checkTokenAndBankAccountMutation(\n  $bankCode: BankCode!\n  $account: String!\n  $code: String!\n) {\n  checkBankAccountByCode(bankCode: $bankCode, account: $account, code: $code) {\n    result\n    errors {\n      code\n    }\n    taxpayerName\n    hometaxBizName\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "eff80825e378d615b061d5e63e0a28a8";

export default node;
